import { Book, BookId, RecordBooks } from "../types";
import { getPercentage, isFinished } from "../utils";
import { CircularProgressWithLabel } from "./CircularProgressWithLabel";
import { FinishedLabel } from "./finishedLable";
import "./library.css";
import { BooksPlaceHolder } from "./BookPlaceHolder";

export const BookComponent = ({
  book,
  onClick,
}: {
  book: Book;
  onClick: any;
}) => {
  return (
    <div className="libraryItem">
      <div className="libraryImageContainer">
        <img
          className="libraryImageBook"
          alt={book.title}
          src={book.imageLink?.thumbnail}
          onClick={onClick}
        />
        <div className="libcircularProsessWithLabel">
          {isFinished(book) ? (
            <FinishedLabel onClick={onClick} />
          ) : (
            <CircularProgressWithLabel
              value={getPercentage(book)}
              size={50}
              onClick={onClick}
            />
          )}
        </div>
      </div>
      <div className="libraryTitle string-cut ">{book.title}</div>
    </div>
  );
};

export const RowLibrary = ({
  books,
  lastBooksRead,
  onSelectBook,
}: {
  books: RecordBooks;
  lastBooksRead: BookId[];
  onSelectBook: any;
}) => {
  const reversableArray = [...lastBooksRead];

  return (
    <div className="libraryContainer">
      <BooksPlaceHolder />
      {reversableArray
        .reverse()
        .map((BookId) => {
          const book = books[BookId];

          return book ? (
            <BookComponent
              key={book.id}
              book={book}
              onClick={() => {
                onSelectBook(book);
              }}
            />
          ) : null;
        })
        .filter((a) => Boolean(a))}
    </div>
  );
};
